import type { RingFinishData } from '@jouzen/ecom-components';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { Ring } from '@/app/[locale]/product/_hooks/types';
import { getFinishPrice } from '@/app/[locale]/product/_utils/getFinishPrice';
import { RingFinishEnum } from '@/app/enums/RingFinishEnum';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';

import wizardData from '../wizardData';

const getRingFinishesData = (
  renderFinishes: Ring[],
  t: (str: MessageKey) => string,
): (RingFinishData | undefined)[] => {
  return renderFinishes.map((ring) => {
    const discountedPrice = ring.discountedPrice.discountedPrice?.amount;
    const price = ring.price?.amount;
    const style =
      ring.style?.length === 0 ? RingStyleEnum.OuraRing4 : ring.style!;
    const finish =
      ring.finish?.length === 0 ? RingFinishEnum.Silver : ring.finish!;

    const { originalPrice, discount } = getFinishPrice({
      discountedAmount: discountedPrice ?? 0,
      showOldPrice: false,
      oldPriceAmount: price ?? 0,
      priceAmount: price ?? 0,
    });

    const _wizardData = wizardData[style][finish];
    const finishStep = _wizardData?.finishStep;
    const selector = finishStep?.selector;

    if (selector) {
      return {
        alt: t(selector.altMsgKey as MessageKey),
        color: t(ring.colorMsgKey as MessageKey),
        discount,
        finish,
        price: originalPrice,
        src: selector.originalSrc,
      };
    }
    return undefined;
  });
};

export default getRingFinishesData;
